import { ApiResource } from '../api-resource';
import { Customer } from '../customer/customer.model';
import { Organization } from '../organization/organization.model';
import { Staff } from '../staff/staff.model';
import { Payment } from './payment.model';

export class PaymentHistory extends ApiResource<PaymentHistory> {
  payments!: Payment[];
  customer?: Customer;
  organization?: Organization;
  staff?: Staff;

  get owner() {
    const owner = this.customer ?? this.staff ?? this.organization;
    if (!owner) throw new Error('Missing payment history owner');
    return owner;
  }
}
